import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';

import {
  StudentsEmojisResponse,
  WalkthroughStatusPayload,
  WalkthroughStatusResponse,
} from './types';
import {
  ClientStateTags,
  getClientStateUrl,
  WALKTHROUGH_STATUS_KEY_V2,
} from './constants';

export const clientStateApi = createApi({
  reducerPath: 'client-state',
  baseQuery: baseQuery(getClientStateUrl),
  tagTypes: [ClientStateTags.WALKTHROUGH],
  endpoints: (builder) => ({
    getStudentsEmojis: builder.mutation<StudentsEmojisResponse, string[]>({
      query: (studentsIds) => ({
        url: `batch-get/student-home-emoji`,
        method: 'POST',
        body: studentsIds,
      }),
      transformResponse: (data) => (Array.isArray(data) ? data : []),
    }),
    getWalkthroughStatus: builder.query<WalkthroughStatusResponse, string>({
      query: (userBk) => `${userBk}/${WALKTHROUGH_STATUS_KEY_V2}`,
      providesTags: [ClientStateTags.WALKTHROUGH],
    }),
    setWalkthroughStatus: builder.mutation<void, WalkthroughStatusPayload>({
      query: ({ userBk, walkthroughStatus }) => ({
        url: `${userBk}/${WALKTHROUGH_STATUS_KEY_V2}`,
        method: 'POST',
        body: walkthroughStatus,
      }),
      invalidatesTags: [ClientStateTags.WALKTHROUGH],
    }),
  }),
});

export const {
  useGetStudentsEmojisMutation,
  useGetWalkthroughStatusQuery,
  useSetWalkthroughStatusMutation,
} = clientStateApi;
